// Ultima actividad del usuario, compartida entre pestañas y persistente al cerrar
// el navegador (oct 2026). Antes el reloj vivia solo en la pagina abierta: cerrar
// la pestaña cerraba la sesion para no dejarla abierta, y eso tiraba al usuario
// con cada F5. Ahora la sesion sobrevive al cierre, pero si al volver pasaron
// mas de INACTIVIDAD_MS sin uso, se pide login igual (celulares prestados).

export const INACTIVIDAD_MS = 2 * 60 * 60 * 1000;   // 2 hs

const CLAVE = 'ultimaActividad';
const CADA_MS = 15 * 1000;   // no escribir en cada mousemove

export function leerUltimaActividad() {
  try { return Number(localStorage.getItem(CLAVE)) || 0; } catch { return 0; }
}

export function marcarActividad(forzar = false) {
  try {
    const ahora = Date.now();
    if (forzar || ahora - leerUltimaActividad() >= CADA_MS) {
      localStorage.setItem(CLAVE, String(ahora));
    }
  } catch { /* sin storage: el reloj de la pagina sigue funcionando */ }
}

export function borrarActividad() {
  try { localStorage.removeItem(CLAVE); } catch { /* nada */ }
}

/** True si hay una marca y es mas vieja que el tope de inactividad. */
export function inactividadVencida() {
  const ultima = leerUltimaActividad();
  return ultima > 0 && Date.now() - ultima > INACTIVIDAD_MS;
}
